<template>
  <div>
    <div class="page flex-col">
    <div class="box_1 flex-col">
      <!-- 头部导航组件 -->
      <HeaderNav />
      
      <div class="news-detail-content flex-col">
      <div class="news-detail-header flex-col" v-if="newsDetail">
        <div class="news-detail-meta flex-row">
          <span class="news-detail-date">{{ formatDate(newsDetail.created_at) }}</span>
        </div>
        <h1 class="news-detail-title">{{ newsDetail.title }}</h1>
      </div>
      
      <div class="news-detail-body flex-col" v-if="newsDetail">
        <div 
          class="news-detail-html"
          v-html="newsDetail.detail || newsDetail.desc"
        ></div>
      </div>
      
      <div class="news-detail-loading flex-col" v-if="loading">
        <p>加载中...</p>
      </div>
      
      <div class="news-detail-empty flex-col" v-if="!loading && !newsDetail">
        <p>新闻不存在</p>
      </div>
      
      <div class="news-detail-actions flex-row">
        <van-button 
          type="default" 
          @click="goBack"
          class="back-btn"
        >
          返回列表
        </van-button>
      </div>
      </div>
      
      <!-- 底部组件 -->
    </div>
    </div>
    <!-- 联系我们部分 - 独立整体 -->
    <ContactUsSection />
  </div>
</template>

<script>
import HeaderNav from '@/components/HeaderNav.vue';
import ContactUsSection from '@/components/ContactUsSection.vue';
import { getNewsDetail } from '@/api/news';

export default {
  name: 'NewsDetail',
  components: {
    HeaderNav,
    ContactUsSection
  },
  data() {
    return {
      newsDetail: null,
      loading: false
    };
  },
  mounted() {
    const newsId = this.$route.params.id;
    if (newsId) {
      this.fetchNewsDetail(newsId);
    }
  },
  methods: {
    // 获取新闻详情
    async fetchNewsDetail(newsId) {
      this.loading = true;
      try {
        const res = await getNewsDetail(newsId);
        if (res.code === 0 && res.data && res.data.row) {
          this.newsDetail = res.data.row;
        } else {
          this.$toast.fail('新闻不存在');
        }
      } catch (error) {
        console.error('获取新闻详情失败:', error);
        this.$toast.fail('获取新闻详情失败');
      } finally {
        this.loading = false;
      }
    },
    // 格式化日期
    formatDate(dateString) {
      if (!dateString) return '';
      const date = new Date(dateString);
      const year = date.getFullYear();
      const month = date.getMonth() + 1;
      const day = date.getDate();
      return `${year}-${month < 10 ? '0' + month : month}-${day < 10 ? '0' + day : day}`;
    },
    // 返回列表
    goBack() {
      this.$router.push('/news');
    }
  }
};
</script>

<style scoped>
.page {
  position: relative;
  width: 1920px;
  height: auto;
  min-height: 100vh;
  overflow-x: hidden;
  overflow-y: auto;
}

.box_1 {
  background-color: rgba(255, 255, 255, 1);
  position: relative;
  width: 1920px;
  min-height: 100vh;
}

.news-detail-content {
  width: 1200px;
  margin: 150px auto 0;
  padding: 40px 0;
}

.news-detail-header {
  margin-bottom: 40px;
  padding-bottom: 30px;
  border-bottom: 2px solid rgba(0, 149, 151, 0.2);
}

.news-detail-meta {
  margin-bottom: 20px;
}

.news-detail-date {
  font-size: 14px;
  color: #999;
}

.news-detail-title {
  font-size: 32px;
  font-weight: bold;
  color: #333;
  margin: 0;
  line-height: 1.4;
}

.news-detail-body {
  margin-bottom: 40px;
  min-height: 200px;
}

.news-detail-html {
  font-size: 16px;
  line-height: 1.8;
  color: #333;
}

.news-detail-html >>> p {
  margin: 0 0 20px 0;
}

.news-detail-html >>> img {
  max-width: 100%;
  height: auto;
  margin: 20px 0;
}

.news-detail-loading,
.news-detail-empty {
  align-items: center;
  justify-content: center;
  padding: 100px 0;
  color: #999;
  font-size: 16px;
}

.news-detail-actions {
  justify-content: center;
  margin-top: 40px;
  padding-top: 40px;
  border-top: 1px solid rgba(0, 149, 151, 0.1);
}

.back-btn {
  padding: 10px 40px;
  color: rgba(0, 149, 151, 1);
  border-color: rgba(0, 149, 151, 1);
}

.footer-wrapper {
  margin: 80px auto 0;
}
</style>

